import { TASK_TYPES } from 'features/daily-plan/constants';

export const FORM_FIELDS_MAP = {
  TaskId: { key: 'id' },
  TaskType: {
    key: 'taskType'
  },
  Interview: {
    key: 'interview'
  },
  ListItems: {
    key: 'items'
  },
  TasksQuery: {
    key: 'tasksQuery'
  },
  Team: {
    key: 'team'
  },
  Recruiter: {
    key: 'recruiter'
  }
};

export const CALLING_TASKS_ID = [
  TASK_TYPES.debriefCall,
  TASK_TYPES.preparationCall,
  TASK_TYPES.closingCall
];
